import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abddd710"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/assets/gk-logo-large.svg"
}, null, -1))
const _hoisted_3 = { class: "course-card__details-container" }
const _hoisted_4 = { class: "course-card__details" }

import { ICourse } from '@/support/models/course.interface';
import { useIonRouter } from '@ionic/vue';
import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseCard',
  props: {
    course: null
  },
  setup(__props: any) {

const props = __props as {
  course: ICourse;
}



const ionRouter = useIonRouter();

const { course } = toRefs(props);

const navigateToCourse = () => {
  ionRouter.navigate(`/course/${course.value.id}`, 'forward', 'push');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "course-card",
    onClick: navigateToCourse
  }, [
    _createElementVNode("img", {
      class: "background-image",
      src: _unref(course).image.url,
      alt: _unref(course).name
    }, null, 8, _hoisted_1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_unref(course).name), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(course).excerpt), 1)
        ])
      ])
    ])
  ]))
}
}

})